export default [
  { title: 'Pfäffikon (SZ)', value: '133219205FE', address: 'H1 Zahnärzte AG\nZentrum Staldenbach 2\n8808 Pfäffikon' },
  { title: 'Kriens (LU)', value: '19C8E37FEE9', address: 'H1 Zahnärzte AG\nPilatusmarkt Ringstraße 19\n6010 Kriens' },
]
